<template>
    <email-verification
        button-id="button-send-verification-code"
        contact-page
        :header="$t('profile.contactInfoPage.contactInformation')"
        :hint="$t('profile.contactInfoPage.subtitle')"
        :title="$t('profile.profileDetailsHeader.title')"
    />
</template>

<script>

// Components
import emailVerification from '@webapp/components/user-details/email-verification.vue';

export default {
    name: 'contact-information',
    components: {
        emailVerification,
    },
};
</script>